export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/dist/cjs.js??ref--10-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--10-3!../../../node_modules/sass-loader/dist/cjs.js??ref--10-4!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./exercisesResource.vue?vue&type=style&index=0&id=55abd118&lang=scss&"


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/exercisesResource.vue?vue&type=style&index=0&id=55abd118&lang=scss&
// module id = izPI
// module chunks = 0